module.exports = require("./d3.js");


//////////////////
// WEBPACK FOOTER
// d3 (bower component)
// module id = 1237
// module chunks = 1